"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToken = exports.useHttp = void 0;
var MSAL = __importStar(require("@azure/msal-browser"));
var useHttp = function (options) {
    var controller = new AbortController();
    var signal = controller.signal;
    var res = {
        fetch: function (url, init) { return __awaiter(void 0, void 0, void 0, function () {
            var headers, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = init ? __assign({}, init.headers) : {};
                        if (!options) return [3, 2];
                        return [4, (0, exports.getToken)(options.msalClient, options.scopes)];
                    case 1:
                        token = _a.sent();
                        headers.Authorization = "Bearer ".concat(token);
                        _a.label = 2;
                    case 2: return [4, fetch(url, __assign(__assign({}, init), { headers: headers, signal: signal }))];
                    case 3: return [2, _a.sent()];
                }
            });
        }); }
    };
    return [res, controller];
};
exports.useHttp = useHttp;
var getToken = function (msalObj, scopes) { return __awaiter(void 0, void 0, void 0, function () {
    var allAccounts, token, error_1, token, e_1, token, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                allAccounts = msalObj.getAllAccounts();
                if (!(allAccounts.length > 0)) return [3, 11];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 10]);
                return [4, msalObj.acquireTokenSilent({
                        account: allAccounts[0],
                        scopes: scopes,
                    })];
            case 2:
                token = _a.sent();
                if (!token.accessToken) {
                    throw new MSAL.InteractionRequiredAuthError();
                }
                return [2, token.accessToken];
            case 3:
                error_1 = _a.sent();
                if (!(error_1 instanceof MSAL.InteractionRequiredAuthError)) return [3, 8];
                _a.label = 4;
            case 4:
                _a.trys.push([4, 6, , 7]);
                return [4, msalObj.acquireTokenPopup({ scopes: scopes })];
            case 5:
                token = _a.sent();
                return [2, token.accessToken];
            case 6:
                e_1 = _a.sent();
                console.log(e_1);
                throw e_1;
            case 7: return [3, 9];
            case 8:
                console.log(error_1);
                throw error_1;
            case 9: return [3, 10];
            case 10: return [3, 14];
            case 11:
                _a.trys.push([11, 13, , 14]);
                return [4, msalObj.acquireTokenPopup({ scopes: scopes })];
            case 12:
                token = _a.sent();
                return [2, token.accessToken];
            case 13:
                e_2 = _a.sent();
                console.log(e_2);
                throw e_2;
            case 14: return [2];
        }
    });
}); };
exports.getToken = getToken;
//# sourceMappingURL=extensions.js.map